export const collapseSpaces = (value: string) => value.replaceAll(/ {2,}/gu, ' ');

export const sanitizeUrlTextParameter = (value: string) =>
  collapseSpaces(
  value
    .replaceAll(/[^\s\dA-Za-z-]/gu, '')
    .trim());